module.exports = __webpack_public_path__ + "static/media/thwj.677cd11f.png";